import { Typography } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  formatDate,
  getNewParameters,
  getObjectSubset,
  getParameters,
  validDate,
} from '../../lib/helper';
import {
  getContrubutorsReport,
  getCompanySalesReportListing,
} from '../../Services/reportsApis';
import * as Yup from 'yup';
import {
  reportListingItemsSelector,
  setAllCompanySalesListing,
} from '../../redux/reports';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MatTable from '../Tables/MatTable';
import AllFilters from '../Order/AllFilters';

const limit = 10;

const column = [
  {
    label: 'Company Name',
    id: 'company_name',
    format: (columnData) => (
      <Typography variant="span" style={{ whiteSpace: 'nowrap' }}>
        {columnData}
      </Typography>
    ),
  },
  {
    label: 'Total Sale',
    id: 'total_sale',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData || 'N/A'}
      </span>
    ),
  },
];

function CompanySaleReport() {
  const [fileResp, setFileResp] = useState({
    status: false,
    data: null,
  });
  const [loading, setLoading] = useState(false);
  const [tableListing, setTableListing] = useState([]);
  const { companySalesReport, mainLoading } = useSelector(
    reportListingItemsSelector,
  );
  const [page, setPage] = useState(1);
  const [allParams, setAllParams] = useState(getParameters());
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [filtersArray, setFiltersArray] = useState([
    {
      label: 'From Date',
      id: 'from',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          newState[1].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: { type: 'date' },
      isVisible: true,
    },
    {
      label: 'To Date',
      id: 'to',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: { type: 'date' },
      isVisible: true,
    },
    {
      label: 'Minimum Amount',
      id: 'min_amount',
      type: 'select',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      dataArr: [
        { label: 'Select', value: '' },
        { label: '5,00,000', value: '500000' },
        { label: '10,00,000', value: '1000000' },
        { label: '15,00,000', value: '1500000' },
        { label: '20,00,000', value: '2000000' },
      ],
      props: {},
      isVisible: true,
    },
  ]);

  const handleFilter = (data, allDatavalues, dataWithValue) => {
    getOrderListing(
      {
        page: String(1),
        ...dataWithValue,
      },
      true,
    );

    setAllParams({
      page: String(1),
      ...dataWithValue,
    });
  };

  const handleClear = () => {
    const data = getObjectSubset({ ...allParams }, 'tab', 'page');
    setAllParams(data);
    setFiltersArray((prevState) => {
      let newState = [...prevState];
      newState[0].isVisible = true;
      newState[1].isVisible = true;
      newState[0].value = '';
      newState[1].value = '';
      newState[2].value = '';
      return newState;
    });
    dispatch(setAllCompanySalesListing());
    setTableListing([]);
  };
  useEffect(() => {
    if (companySalesReport?.items?.length >= 0) {
      setTableListing(companySalesReport?.items);
    }
  }, [companySalesReport?.items]);

  useEffect(() => {
    dispatch(setAllCompanySalesListing());
    // Clean up when leaving the component
     return () => {
    dispatch(setAllCompanySalesListing());
  };
  }, []);

  const formik = useFormik({
    initialValues: {
      from: '',
      to: '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      from: Yup.string().required('From Date is required.'),
      to: Yup.string().required('To Date is required.'),
    }),
    onSubmit: checking,
  });

  async function checking() {
    setLoading(true);
    let resp = await getContrubutorsReport(formik.values);
    setLoading(false);
  }
  const getOrderListing = async (params = {}) => {
    const combinedParams = {
      page: String(1),
      limit: limit,
      ...allParams,
      ...params,
    };

    const { from, to, min_amount, ...rest } = combinedParams;

    if (!from || !to) {
      toast.error('Start and End Date required!');
      return;
    }

    const payload = {
      ...rest,
      date_from: formatDate(from, 'yyyy-mm-dd') + ' 00:00:00',
      date_to: formatDate(to, 'yyyy-mm-dd') + ' 23:59:59',
      ...(min_amount && { min_amount }),
    };
    dispatch(getCompanySalesReportListing(payload));
    setPage(Number(payload.page));
  };

  useEffect(() => {
    let data = getNewParameters(allParams);
    if (formik?.values?.start_date && formik?.values?.end_date) {
      if (data?.search !== location.search) {
        navigate(data.newUrl, { replace: false });
        if (data?.parameters?.page) {
          setPage(Number(data?.parameters?.page));
        }
      }
      getOrderListing();
    }
  }, [allParams]);

  return (
    <>
      <MatTable
        loading={companySalesReport?.loading}
        showCheckbox={false}
        columns={column}
        data={tableListing}
        onApplyFilter={(data = {}) => {
          getListing({
            page: String(1),
            start_date: '',
            end_date: '',
            ...getObjectSubset(data, 'start_date', 'end_date'),
          });
          if (Object.keys(data).length > 0) {
            setAllParams({
              ...allParams,
              page: String(1),
              ...getObjectSubset(data, 'start_date', 'end_date'),
            });
          } else {
            setAllParams({
              page: String(1),
            });
          }
        }}
        page={page}
        perPage={limit}
        total={companySalesReport?.items?.length || 0}
        setPage={setPage}
        handleSearch={(searchTerm) => {
          getListing({
            page: String(1),
            search: searchTerm,
          });
          setAllParams({
            ...allParams,
            page: String(1),
            search: searchTerm,
          });
        }}
        handlePageChange={(newPage) => {
          getOrderListing({
            page: String(newPage),
          });
          setAllParams({
            ...allParams,
            page: String(newPage),
          });
        }}
        toolbarEnable={true}
        customFilter={() => (
          <AllFilters
            filtersArray={filtersArray}
            handleClick={handleFilter}
            handleClear={handleClear}
          />
        )}
        pagination={true}
        filtersUrlData={allParams || {}}
        disableSearch
      />
    </>
  );
}

export default CompanySaleReport;
